import { styled } from "@/stitches/config"

export const SAccordion = styled("div", {})
